
// import React, { useState, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { axios } from '../contexts/AuthContext';
// import FilterPanel from '../components/FilterPanel';
// import toast from 'react-hot-toast';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import * as XLSX from 'xlsx';

// export default function DataFetches() {
//   const navigate = useNavigate();
//   const [filters, setFilters] = useState({});
//   const [data, setData] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const [fetched, setFetched] = useState(false);
//   const isMobile = window.innerWidth < 768;
//   const totalActive = Object.values(filters).flat().length;

//   const buildParams = f => {
//     const p = {};
//     if(f.districts?.length)   p.districts    = f.districts.join(',');
//     if(f.communities?.length) p.communities  = f.communities.join(',');
//     if(f.genders?.length)     p.genders      = f.genders.join(',');
//     if(f.age_groups?.length)  p.age_groups   = f.age_groups.join(',');
//     if(f.professions?.length) p.professions  = f.professions.join(',');
//     if(f.booth_number)        p.booth_number = f.booth_number;
//     return p;
//   };

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const { data:res } = await axios.get('/voters/export/data', { params:{...buildParams(filters),limit:10000} });
//       setData(res.data); setTotal(res.total); setFetched(true);
//       toast.success(`✅ ${res.total.toLocaleString()} records loaded`);
//       if(isMobile) setShowFilters(false);
//     } catch { toast.error('Failed to fetch data'); }
//     finally { setLoading(false); }
//   }, [filters]);

//   const handleClear = () => { setFilters({}); setData([]); setTotal(0); setFetched(false); };

//   const downloadPDF = async () => {
//     if(!data.length){toast.error('No data');return;}
//     const t = toast.loading('Generating PDF...');
//     const doc = new jsPDF('l','mm','a4');
//     const W = 297;

//     // Header background
//     doc.setFillColor(229,81,0); doc.rect(0,0,W,22,'F');
//     doc.setFillColor(19,136,8); doc.rect(0,19,W,4,'F');

//     // Modi on LEFT (circle)
//     try {
//       const modiRes = await fetch(window.location.origin + '/images/modi.png');
//       const modiBlob = await modiRes.blob();
//       const modiData = await new Promise(r => { const fr=new FileReader(); fr.onload=e=>r(e.target.result); fr.readAsDataURL(modiBlob); });
//       const modiImg = new Image(); await new Promise(r => { modiImg.onload=r; modiImg.src=modiData; });
//       const s=Math.min(modiImg.naturalWidth,modiImg.naturalHeight);
//       const c=document.createElement('canvas'); c.width=s; c.height=s;
//       const ctx=c.getContext('2d'); ctx.beginPath(); ctx.arc(s/2,s/2,s/2,0,Math.PI*2); ctx.clip();
//       ctx.drawImage(modiImg,-(modiImg.naturalWidth-s)/2,-(modiImg.naturalHeight-s)/2);
//       doc.addImage(c.toDataURL('image/png'),'PNG',2,1,18,18);
//     } catch(e){ console.log('Modi error:',e); }

//     // BJP Logo on RIGHT (circle)
//     try {
//       const bjpRes = await fetch(window.location.origin + '/images/bjp-logo.png');
//       const bjpBlob = await bjpRes.blob();
//       const bjpData = await new Promise(r => { const fr=new FileReader(); fr.onload=e=>r(e.target.result); fr.readAsDataURL(bjpBlob); });
//       const bjpImg = new Image(); await new Promise(r => { bjpImg.onload=r; bjpImg.src=bjpData; });
//       const s=Math.min(bjpImg.naturalWidth,bjpImg.naturalHeight);
//       const c=document.createElement('canvas'); c.width=s; c.height=s;
//       const ctx=c.getContext('2d'); ctx.beginPath(); ctx.arc(s/2,s/2,s/2,0,Math.PI*2); ctx.clip();
//       ctx.drawImage(bjpImg,-(bjpImg.naturalWidth-s)/2,-(bjpImg.naturalHeight-s)/2);
//       doc.addImage(c.toDataURL('image/png'),'PNG',W-20,1,18,18);
//     } catch(e){ console.log('BJP error:',e); }

//     // Party name CENTER
//     doc.setTextColor(255,255,255);
//     doc.setFontSize(14); doc.setFont(undefined,'bold');
//     doc.text('Bharatiya Janata Party', W/2, 10, {align:'center'});
//     doc.setFontSize(8); doc.setFont(undefined,'normal');
//     doc.text(`Voter Data Export  |  Total: ${total.toLocaleString()}  |  ${new Date().toLocaleDateString('en-IN')}`, W/2, 17, {align:'center'});

//     // Table
//     doc.autoTable({
//       head:[['#','Name','Relative','G/Age','Mobile','District','Booth','S.No','Community','Profession','Status']],
//       body: data.map((r,i)=>[i+1,r.name,r.relation_name||'',`${r.gender}/${r.age}`,r.mobile?'..'+String(r.mobile).slice(-4):'',r.district||'',r.booth_number||'',r.serial_number||'',r.community||'',r.profession||'',r.status||'']),
//       startY:25, styles:{fontSize:6.5,cellPadding:1.5},
//       headStyles:{fillColor:[229,81,0],textColor:255,fontStyle:'bold'},
//       alternateRowStyles:{fillColor:[255,248,240]}, margin:{left:4,right:4},
//     });

//     // Footer
//     const pageCount = doc.internal.getNumberOfPages();
//     for(let i=1; i<=pageCount; i++) {
//       doc.setPage(i);
//       const pageH = doc.internal.pageSize.height;
//       doc.setFillColor(229,81,0); doc.rect(0,pageH-10,W,10,'F');
//       doc.setTextColor(255,255,255); doc.setFontSize(7); doc.setFont(undefined,'normal');
//       doc.text(`Printed on ${new Date().toLocaleString('en-IN')} | Voter App by Influfly`, W/2, pageH-3, {align:'center'});
//     }

//     doc.save(`voter_export_${new Date().toISOString().split('T')[0]}.pdf`);
//     toast.dismiss(t); toast.success('📄 PDF downloaded!');
//   };

//   const downloadExcel = () => {
//     if(!data.length){toast.error('No data');return;}
//     const t = toast.loading('Generating Excel...');
//     const ws = XLSX.utils.json_to_sheet(data.map(r=>({'Name':r.name,'Relative':r.relation_name||'','Gender':r.gender,'Age':r.age,'Mobile':r.mobile||'','UU ID':r.epic_id||'','Address':r.address||'','District':r.district||'','Booth No':r.booth_number||'','Serial No':r.serial_number||'','Area':r.area||'','Status':r.status||'','Community':r.community||'','Profession':r.profession||'','Education':r.degree||'','Mother Tongue':r.mother_tongue||'','Reference':r.reference_name||''})));
//     const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb,ws,'Voters');
//     XLSX.writeFile(wb,`voter_export_${new Date().toISOString().split('T')[0]}.xlsx`);
//     toast.dismiss(t); toast.success('📊 Excel downloaded!');
//   };

//   return (
//     <div style={{minHeight:'100vh',background:'linear-gradient(160deg,#FFF4ED,#FFF8F0)',fontFamily:"'Outfit',sans-serif"}}>

//       {/* Header */}
//       <div className="app-header">
//         <div style={{display:'flex',alignItems:'center',gap:10}}>
//           <button className="back-btn" onClick={()=>navigate('/')}>←</button>
//           <div>
//             <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:700,fontSize:'1.05rem',color:'white'}}>📥 Data Fetches</div>
//             <div style={{fontSize:'0.65rem',opacity:.82,color:'white'}}>
//               {fetched ? `${total.toLocaleString()} records loaded` : 'Select filters & fetch data'}
//             </div>
//           </div>
//         </div>

//         {/* Right side — Filter + Download */}
//         <div style={{display:'flex',gap:8,alignItems:'center'}}>
//           {/* Filter button — icon only on mobile, icon+text on desktop */}
//           <button onClick={()=>setShowFilters(!showFilters)} style={{
//             background: totalActive>0 ? 'white' : 'rgba(255,255,255,0.18)',
//             border: '1.5px solid rgba(255,255,255,0.4)',
//             color: totalActive>0 ? '#E55100' : 'white',
//             padding:'7px 14px',
//             borderRadius:10, cursor:'pointer',
//             fontWeight:700, fontSize:'0.78rem',
//             display:'flex', alignItems:'center', gap:6,
//             transition:'all 0.2s',
//           }}>
//             <span style={{fontSize:'0.9rem'}}>🎛️</span>
//             <span>Filters</span>
//             {totalActive>0 && <span style={{background:'#E55100',color:'white',borderRadius:99,padding:'1px 7px',fontSize:'0.65rem',fontWeight:800}}>{totalActive}</span>}
//           </button>

//           {/* PDF + Excel — hidden on mobile */}
//           {!isMobile && fetched && <>
//             <button onClick={downloadPDF} style={{background:'rgba(255,255,255,0.18)',border:'1.5px solid rgba(255,255,255,0.4)',color:'white',padding:'7px 14px',borderRadius:10,cursor:'pointer',fontWeight:700,fontSize:'0.78rem',display:'flex',alignItems:'center',gap:5,transition:'all 0.2s'}}
//             onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.3)'} onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.18)'}>
//               <span>📄</span><span>PDF</span>
//             </button>
//             <button onClick={downloadExcel} style={{background:'rgba(255,255,255,0.18)',border:'1.5px solid rgba(255,255,255,0.4)',color:'white',padding:'7px 14px',borderRadius:10,cursor:'pointer',fontWeight:700,fontSize:'0.78rem',display:'flex',alignItems:'center',gap:5,transition:'all 0.2s'}}
//             onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.3)'} onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.18)'}>
//               <span>📊</span><span>Excel</span>
//             </button>
//           </>}
//         </div>
//       </div>

//       {/* Mobile filter sheet */}
//       {isMobile && showFilters && (
//         <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:300,display:'flex',flexDirection:'column',justifyContent:'flex-end'}} onClick={()=>setShowFilters(false)}>
//           <div style={{background:'white',borderRadius:'20px 20px 0 0',padding:16,maxHeight:'80vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
//             <div style={{display:'flex',justifyContent:'space-between',marginBottom:12}}>
//               <strong style={{fontSize:'1rem',color:'#BF360C'}}>🎛️ Filters</strong>
//               <button onClick={()=>setShowFilters(false)} style={{background:'none',border:'none',fontSize:'1.2rem',cursor:'pointer'}}>✕</button>
//             </div>
//             <FilterPanel filters={filters} onChange={setFilters} onApply={fetchData} onClear={handleClear}/>
//           </div>
//         </div>
//       )}

//       <div style={{display:'flex',gap:16,padding:isMobile?'12px':'16px',maxWidth:1400,margin:'0 auto',alignItems:'flex-start'}}>

//         {/* Table — LEFT */}
//         <div style={{flex:1,minWidth:0}}>
//           {!fetched ? (
//             <div style={{background:'rgba(255,255,255,0.85)',borderRadius:20,padding:'48px 24px',textAlign:'center',border:'2px dashed rgba(255,107,0,0.2)',backdropFilter:'blur(10px)'}}>
//               <div style={{fontSize:'3rem',marginBottom:12}}>📊</div>
//               <div style={{fontFamily:"'Baloo 2',sans-serif",fontSize:'1.1rem',fontWeight:700,color:'#BF360C',marginBottom:6}}>Select Filters & Fetch Data</div>
//               <div style={{color:'#9E6040',fontSize:'0.82rem',marginBottom:16}}>Use filters on the right, then click Fetch Data</div>
//               <button onClick={fetchData} disabled={loading} style={{padding:'11px 28px',border:'none',borderRadius:12,background:'linear-gradient(135deg,#E55100,#FF6B00)',color:'white',fontWeight:700,fontSize:'0.9rem',cursor:'pointer',boxShadow:'0 4px 14px rgba(255,107,0,0.4)',fontFamily:"'Outfit',sans-serif"}}>
//                 {loading?'Fetching...':'🔄 Fetch All Data'}
//               </button>
//             </div>
//           ) : (
//             <div style={{background:'rgba(255,255,255,0.9)',borderRadius:16,border:'1px solid rgba(255,255,255,0.7)',boxShadow:'0 4px 20px rgba(255,107,0,0.08)',overflow:'hidden'}}>
//               <div style={{padding:'12px 16px',borderBottom:'2px solid rgba(255,107,0,0.1)',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
//                 <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:700,color:'#BF360C',fontSize:'0.95rem'}}>📋 {total.toLocaleString()} Records</div>
//                 <div style={{display:'flex',gap:8}}>
//                   <button onClick={downloadPDF} style={{padding:'6px 14px',border:'none',borderRadius:99,background:'linear-gradient(135deg,#B71C1C,#E53935)',color:'white',fontWeight:700,fontSize:'0.75rem',cursor:'pointer',boxShadow:'0 3px 8px rgba(183,28,28,0.35)'}}>📄 PDF</button>
//                   <button onClick={downloadExcel} style={{padding:'6px 14px',border:'none',borderRadius:99,background:'linear-gradient(135deg,#1B5E20,#2E7D32)',color:'white',fontWeight:700,fontSize:'0.75rem',cursor:'pointer',boxShadow:'0 3px 8px rgba(27,94,32,0.35)'}}>📊 Excel</button>
//                 </div>
//               </div>
//               <div style={{overflowX:'auto',maxHeight:'calc(100vh - 220px)',overflowY:'auto'}}>
//                 <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.78rem',fontFamily:"'Outfit',sans-serif"}}>
//                   <thead style={{position:'sticky',top:0,zIndex:5}}>
//                     <tr style={{background:'linear-gradient(135deg,#E55100,#FF6B00)',color:'white'}}>
//                       {['#','Name','Relative','G/Age','District','Booth','Community','Profession','Status'].map(h=>(
//                         <th key={h} style={{padding:'9px 10px',textAlign:'left',fontWeight:700,fontSize:'0.72rem',whiteSpace:'nowrap'}}>{h}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {data.map((row,i)=>(
//                       <tr key={i} style={{borderBottom:'1px solid rgba(255,107,0,0.05)',transition:'background 0.1s'}}
//                       onMouseEnter={e=>e.currentTarget.style.background='rgba(255,107,0,0.03)'}
//                       onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
//                         <td style={{padding:'8px 10px',color:'#9E6040',fontSize:'0.7rem'}}>{i+1}</td>
//                         <td style={{padding:'8px 10px',fontWeight:600,color:'#1A0A00'}}>{row.name}</td>
//                         <td style={{padding:'8px 10px',color:'#5C3010'}}>{row.relation_name||'—'}</td>
//                         <td style={{padding:'8px 10px'}}><span style={{background:row.gender==='M'?'#E3F2FD':'#FCE4EC',color:row.gender==='M'?'#1565C0':'#880E4F',padding:'2px 7px',borderRadius:99,fontWeight:700,fontSize:'0.7rem'}}>{row.gender}/{row.age}</span></td>
//                         <td style={{padding:'8px 10px',color:'#5C3010',fontSize:'0.78rem'}}>{row.district||'—'}</td>
//                         <td style={{padding:'8px 10px',fontWeight:700,color:'#E55100'}}>{row.booth_number||'—'}</td>
//                         <td style={{padding:'8px 10px',color:'#333',fontSize:'0.76rem'}}>{row.community||'—'}</td>
//                         <td style={{padding:'8px 10px',color:'#333',fontSize:'0.76rem'}}>{row.profession||'—'}</td>
//                         <td style={{padding:'8px 10px'}}><span style={{background:row.status==='Available'?'#E8F5E9':'#F5F5F5',color:row.status==='Available'?'#1B5E20':'#666',padding:'2px 7px',borderRadius:99,fontWeight:700,fontSize:'0.7rem'}}>{row.status||'None'}</span></td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Filters — RIGHT (desktop) */}
//         {!isMobile && (
//           <div style={{width:260,flexShrink:0,position:'sticky',top:16}}>
//             <FilterPanel filters={filters} onChange={setFilters} onApply={fetchData} onClear={handleClear}/>
//             <button onClick={fetchData} disabled={loading} style={{width:'100%',marginTop:10,padding:'12px',border:'none',borderRadius:12,background:'linear-gradient(135deg,#1565C0,#1976D2)',color:'white',fontWeight:700,fontSize:'0.88rem',cursor:'pointer',fontFamily:"'Outfit',sans-serif",boxShadow:'0 4px 14px rgba(21,101,192,0.35)',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
//               {loading?<><span style={{width:14,height:14,border:'2px solid rgba(255,255,255,0.4)',borderTopColor:'white',borderRadius:'50%',display:'inline-block',animation:'spin 0.7s linear infinite'}}/>Fetching...</>:'🔄 Fetch Data'}
//             </button>
//           </div>
//         )}
//       </div>
//       <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
//     </div>
//   );
// }





















import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { axios } from '../contexts/AuthContext';
import FilterPanel from '../components/FilterPanel';
import toast from 'react-hot-toast';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

export default function DataFetches() {
  const navigate  = useNavigate();
  const [filters, setFilters]       = useState({});
  const [data, setData]             = useState([]);
  const [total, setTotal]           = useState(0);
  const [loading, setLoading]       = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [fetched, setFetched]       = useState(false);
  const isMobile = window.innerWidth < 768;
  const totalActive = Object.values(filters).flat().filter(v=>v!==undefined&&v!=='').length;

  const buildParams = f => {
    const p = {};
    if(f.districts?.length)   p.districts    = f.districts.join(',');
    if(f.communities?.length) p.communities  = f.communities.join(',');
    if(f.genders?.length)     p.genders      = f.genders.join(',');
    if(f.age_groups?.length)  p.age_groups   = f.age_groups.join(',');
    if(f.professions?.length) p.professions  = f.professions.join(',');
    if(f.booth_number)        p.booth_number = f.booth_number;
    return p;
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data:res } = await axios.get('/voters/export/data', { params:{...buildParams(filters),limit:10000} });
      setData(res.data); setTotal(res.total); setFetched(true);
      toast.success(`✅ ${res.total.toLocaleString()} records loaded`);
      if(isMobile) setShowFilters(false);
    } catch { toast.error('Failed to fetch data'); }
    finally { setLoading(false); }
  }, [filters]);

  const handleClear = () => { setFilters({}); setData([]); setTotal(0); setFetched(false); };

  const downloadPDF = async () => {
    if(!data.length){toast.error('No data');return;}
    const t = toast.loading('Generating PDF...');
    const doc = new jsPDF('l','mm','a4');
    const W = 297;
    doc.setFillColor(229,81,0); doc.rect(0,0,W,22,'F');
    doc.setFillColor(19,136,8); doc.rect(0,19,W,4,'F');
    try {
      const modiRes = await fetch(window.location.origin+'/images/modi.png');
      const modiBlob = await modiRes.blob();
      const modiData = await new Promise(r=>{const fr=new FileReader();fr.onload=e=>r(e.target.result);fr.readAsDataURL(modiBlob);});
      const modiImg = new Image(); await new Promise(r=>{modiImg.onload=r;modiImg.src=modiData;});
      const s=Math.min(modiImg.naturalWidth,modiImg.naturalHeight);
      const c=document.createElement('canvas');c.width=s;c.height=s;
      const ctx=c.getContext('2d');ctx.beginPath();ctx.arc(s/2,s/2,s/2,0,Math.PI*2);ctx.clip();
      ctx.drawImage(modiImg,-(modiImg.naturalWidth-s)/2,-(modiImg.naturalHeight-s)/2);
      doc.addImage(c.toDataURL('image/png'),'PNG',2,1,18,18);
    } catch(e){console.log('Modi error:',e);}
    try {
      const bjpRes = await fetch(window.location.origin+'/images/bjp-logo.png');
      const bjpBlob = await bjpRes.blob();
      const bjpData = await new Promise(r=>{const fr=new FileReader();fr.onload=e=>r(e.target.result);fr.readAsDataURL(bjpBlob);});
      const bjpImg = new Image(); await new Promise(r=>{bjpImg.onload=r;bjpImg.src=bjpData;});
      const s=Math.min(bjpImg.naturalWidth,bjpImg.naturalHeight);
      const c=document.createElement('canvas');c.width=s;c.height=s;
      const ctx=c.getContext('2d');ctx.beginPath();ctx.arc(s/2,s/2,s/2,0,Math.PI*2);ctx.clip();
      ctx.drawImage(bjpImg,-(bjpImg.naturalWidth-s)/2,-(bjpImg.naturalHeight-s)/2);
      doc.addImage(c.toDataURL('image/png'),'PNG',W-20,1,18,18);
    } catch(e){console.log('BJP error:',e);}
    doc.setTextColor(255,255,255);
    doc.setFontSize(14);doc.setFont(undefined,'bold');
    doc.text('Bharatiya Janata Party',W/2,10,{align:'center'});
    doc.setFontSize(8);doc.setFont(undefined,'normal');
    doc.text(`Voter Data Export  |  Total: ${total.toLocaleString()}  |  ${new Date().toLocaleDateString('en-IN')}`,W/2,17,{align:'center'});
    doc.autoTable({
      head:[['#','Name','Relative','G/Age','Mobile','District','Booth','S.No','Community','Profession','Status']],
      body:data.map((r,i)=>[i+1,r.name,r.relation_name||'',`${r.gender}/${r.age}`,r.mobile?'..'+String(r.mobile).slice(-4):'',r.district||'',r.booth_number||'',r.serial_number||'',r.community||'',r.profession||'',r.status||'']),
      startY:25,styles:{fontSize:6.5,cellPadding:1.5},
      headStyles:{fillColor:[229,81,0],textColor:255,fontStyle:'bold'},
      alternateRowStyles:{fillColor:[255,248,240]},margin:{left:4,right:4},
    });
    const pageCount=doc.internal.getNumberOfPages();
    for(let i=1;i<=pageCount;i++){
      doc.setPage(i);const pageH=doc.internal.pageSize.height;
      doc.setFillColor(229,81,0);doc.rect(0,pageH-10,W,10,'F');
      doc.setTextColor(255,255,255);doc.setFontSize(7);doc.setFont(undefined,'normal');
      doc.text(`Printed on ${new Date().toLocaleString('en-IN', { timeZone:'Asia/Kolkata' })} | Voter App by Influfly`,W/2,pageH-3,{align:'center'});
    }
    doc.save(`voter_export_${new Date().toISOString().split('T')[0]}.pdf`);
    toast.dismiss(t);toast.success('📄 PDF downloaded!');
  };

  const downloadExcel = () => {
    if(!data.length){toast.error('No data');return;}
    const t=toast.loading('Generating Excel...');
    const ws=XLSX.utils.json_to_sheet(data.map(r=>({'Name':r.name,'Relative':r.relation_name||'','Gender':r.gender,'Age':r.age,'Mobile':r.mobile||'','UU ID':r.epic_id||'','Address':r.address||'','District':r.district||'','Booth No':r.booth_number||'','Serial No':r.serial_number||'','Area':r.area||'','Status':r.status||'','Community':r.community||'','Profession':r.profession||'','Education':r.degree||'','Mother Tongue':r.mother_tongue||'','Reference':r.reference_name||''})));
    const wb=XLSX.utils.book_new();XLSX.utils.book_append_sheet(wb,ws,'Voters');
    XLSX.writeFile(wb,`voter_export_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.dismiss(t);toast.success('📊 Excel downloaded!');
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(160deg,#FFF4ED,#FFF8F0)',fontFamily:"'Outfit',sans-serif"}}>

      {/* Header */}
      <div className="app-header">
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <button className="back-btn" onClick={()=>navigate('/')}>←</button>
          <div>
            <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:700,fontSize:'1.05rem',color:'white'}}>📥 Data Fetcher</div>
            <div style={{fontSize:'0.65rem',opacity:.82,color:'white'}}>
              {fetched?`${total.toLocaleString()} records`:'Select filters & fetch'}
            </div>
          </div>
        </div>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <button onClick={()=>setShowFilters(!showFilters)} style={{background:totalActive>0?'white':'rgba(255,255,255,0.18)',border:'1.5px solid rgba(255,255,255,0.4)',color:totalActive>0?'#E55100':'white',padding:'7px 12px',borderRadius:10,cursor:'pointer',fontWeight:700,fontSize:'0.78rem',display:'flex',alignItems:'center',gap:5,transition:'all 0.2s'}}>
            <span>🎛️</span><span>Filters</span>
            {totalActive>0&&<span style={{background:'#E55100',color:'white',borderRadius:99,padding:'1px 7px',fontSize:'0.65rem',fontWeight:800}}>{totalActive}</span>}
          </button>
          {!isMobile&&fetched&&<>
            <button onClick={downloadPDF} style={{background:'rgba(255,255,255,0.18)',border:'1.5px solid rgba(255,255,255,0.4)',color:'white',padding:'7px 12px',borderRadius:10,cursor:'pointer',fontWeight:700,fontSize:'0.78rem',display:'flex',alignItems:'center',gap:5}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.3)'} onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.18)'}>
              <span>📄</span><span>PDF</span>
            </button>
            <button onClick={downloadExcel} style={{background:'rgba(255,255,255,0.18)',border:'1.5px solid rgba(255,255,255,0.4)',color:'white',padding:'7px 12px',borderRadius:10,cursor:'pointer',fontWeight:700,fontSize:'0.78rem',display:'flex',alignItems:'center',gap:5}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.3)'} onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.18)'}>
              <span>📊</span><span>Excel</span>
            </button>
          </>}
        </div>
      </div>

      {/* Filter sheet (bottom sheet on mobile) */}
      {showFilters&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:300,display:'flex',flexDirection:'column',justifyContent:isMobile?'flex-end':'flex-start',alignItems:isMobile?'stretch':'flex-end',paddingTop:isMobile?0:70,paddingRight:isMobile?0:16}} onClick={()=>setShowFilters(false)}>
          <div style={{background:'white',borderRadius:isMobile?'20px 20px 0 0':'20px',padding:16,maxHeight:'80vh',overflowY:'auto',width:isMobile?'100%':280}} onClick={e=>e.stopPropagation()}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:12}}>
              <strong style={{fontSize:'1rem',color:'#BF360C'}}>🎛️ Filters</strong>
              <button onClick={()=>setShowFilters(false)} style={{background:'none',border:'none',fontSize:'1.2rem',cursor:'pointer'}}>✕</button>
            </div>
            <FilterPanel filters={filters} onChange={setFilters} onApply={()=>{fetchData();setShowFilters(false);}} onClear={handleClear}/>
            <button onClick={()=>{fetchData();setShowFilters(false);}} disabled={loading} style={{width:'100%',marginTop:12,padding:'12px',border:'none',borderRadius:12,background:'linear-gradient(135deg,#E55100,#FF6B00)',color:'white',fontWeight:700,fontSize:'0.9rem',cursor:'pointer',fontFamily:"'Outfit',sans-serif",display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
              {loading?<><span style={{width:14,height:14,border:'2px solid rgba(255,255,255,0.4)',borderTopColor:'white',borderRadius:'50%',display:'inline-block',animation:'spin 0.7s linear infinite'}}/>Loading...</>:'🔄 Fetch Data'}
            </button>
          </div>
        </div>
      )}

      <div style={{padding:isMobile?'12px 12px 80px':'16px',maxWidth:isMobile?'100%':1400,margin:'0 auto'}}>

        {/* ── NOT FETCHED ── */}
        {!fetched&&(
          <div style={{background:'rgba(255,255,255,0.9)',borderRadius:20,padding:'48px 24px',textAlign:'center',border:'2px dashed rgba(255,107,0,0.2)'}}>
            <div style={{fontSize:'3.5rem',marginBottom:14}}>📊</div>
            <div style={{fontFamily:"'Baloo 2',sans-serif",fontSize:'1.15rem',fontWeight:700,color:'#BF360C',marginBottom:6}}>Select Filters & Fetch</div>
            <div style={{color:'#9E6040',fontSize:'0.82rem',marginBottom:20}}>Apply filters then tap below to load voter data</div>
            <button onClick={fetchData} disabled={loading} style={{padding:'13px 32px',border:'none',borderRadius:14,background:'linear-gradient(135deg,#E55100,#FF6B00)',color:'white',fontWeight:700,fontSize:'0.95rem',cursor:'pointer',boxShadow:'0 4px 14px rgba(255,107,0,0.4)',fontFamily:"'Outfit',sans-serif",display:'inline-flex',alignItems:'center',gap:8}}>
              {loading?<><span style={{width:16,height:16,border:'2px solid rgba(255,255,255,0.4)',borderTopColor:'white',borderRadius:'50%',display:'inline-block',animation:'spin 0.7s linear infinite'}}/>Fetching...</>:'🔄 Fetch All Data'}
            </button>
          </div>
        )}

        {/* ── FETCHED: MOBILE CARD VIEW ── */}
        {fetched&&isMobile&&(
          <div>
            {/* Stats + Download bar */}
            <div style={{display:'grid',gridTemplateColumns:'1fr auto auto',gap:8,marginBottom:14,alignItems:'stretch'}}>
              <div style={{background:'linear-gradient(135deg,#E55100,#FF6B00)',borderRadius:14,padding:'12px 16px',color:'white'}}>
                <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:800,fontSize:'1.4rem',lineHeight:1}}>{total.toLocaleString()}</div>
                <div style={{fontSize:'0.65rem',opacity:.85,marginTop:2,fontWeight:600}}>Total Records</div>
              </div>
              <button onClick={downloadPDF} style={{background:'linear-gradient(135deg,#B71C1C,#E53935)',border:'none',borderRadius:14,padding:'0 14px',color:'white',fontWeight:700,fontSize:'0.75rem',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,boxShadow:'0 3px 10px rgba(183,28,28,0.3)'}}>
                <span style={{fontSize:'1.3rem'}}>📄</span>
                <span>PDF</span>
              </button>
              <button onClick={downloadExcel} style={{background:'linear-gradient(135deg,#1B5E20,#2E7D32)',border:'none',borderRadius:14,padding:'0 14px',color:'white',fontWeight:700,fontSize:'0.75rem',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,boxShadow:'0 3px 10px rgba(27,94,32,0.3)'}}>
                <span style={{fontSize:'1.3rem'}}>📊</span>
                <span>Excel</span>
              </button>
            </div>

            {/* Voter Cards */}
            {data.map((row,i)=>(
              <div key={i} style={{background:'rgba(255,255,255,0.94)',borderRadius:16,padding:'14px 16px',marginBottom:10,border:'1px solid rgba(255,107,0,0.1)',boxShadow:'0 2px 12px rgba(0,0,0,0.05)'}}>
                {/* Top row */}
                <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:8}}>
                  {/* Avatar */}
                  <div style={{width:40,height:40,borderRadius:12,background:row.gender==='F'?'linear-gradient(135deg,#FCE4EC,#F48FB1)':'linear-gradient(135deg,#E3F2FD,#90CAF9)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:'1rem',color:row.gender==='F'?'#880E4F':'#1565C0',flexShrink:0}}>
                    {row.name?.charAt(0)}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,fontSize:'0.92rem',color:'#1A0A00',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{row.name}</div>
                    {row.relation_name&&<div style={{fontSize:'0.72rem',color:'#9E6040',marginTop:1,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{row.relation_name}</div>}
                  </div>
                  <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:4,flexShrink:0}}>
                    <span style={{background:row.gender==='M'?'#E3F2FD':'#FCE4EC',color:row.gender==='M'?'#1565C0':'#880E4F',padding:'2px 8px',borderRadius:99,fontWeight:700,fontSize:'0.7rem'}}>{row.gender}/{row.age}</span>
                    {row.serial_number&&<span style={{background:'#FFF3E0',color:'#E55100',padding:'1px 7px',borderRadius:99,fontWeight:700,fontSize:'0.68rem'}}>#{row.serial_number}</span>}
                  </div>
                </div>
                {/* Chips row */}
                <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                  {row.booth_number&&<span style={{background:'#FFF3E0',color:'#E55100',padding:'3px 9px',borderRadius:8,fontSize:'0.68rem',fontWeight:700,border:'1px solid rgba(255,107,0,0.2)'}}>🏫 Booth {row.booth_number}</span>}
                  {row.district&&<span style={{background:'#F3E5F5',color:'#6A1B9A',padding:'3px 9px',borderRadius:8,fontSize:'0.68rem',fontWeight:600}}>🗺️ {row.district}</span>}
                  {row.community&&<span style={{background:'#E3F2FD',color:'#1565C0',padding:'3px 9px',borderRadius:8,fontSize:'0.68rem',fontWeight:600}}>{row.community}</span>}
                  {row.profession&&<span style={{background:'#E8F5E9',color:'#2E7D32',padding:'3px 9px',borderRadius:8,fontSize:'0.68rem',fontWeight:600}}>{row.profession}</span>}
                  {row.status&&row.status!=='None'&&<span style={{background:row.status==='Available'?'#E8F5E9':row.status==='Expired'?'#FFEBEE':'#FFF9C4',color:row.status==='Available'?'#1B5E20':row.status==='Expired'?'#C62828':'#F57F17',padding:'3px 9px',borderRadius:8,fontSize:'0.68rem',fontWeight:600}}>{row.status}</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── FETCHED: DESKTOP TABLE VIEW ── */}
        {fetched&&!isMobile&&(
          <div style={{background:'rgba(255,255,255,0.9)',borderRadius:16,border:'1px solid rgba(255,255,255,0.7)',boxShadow:'0 4px 20px rgba(255,107,0,0.08)',overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'2px solid rgba(255,107,0,0.1)',display:'flex',justifyContent:'space-between',alignItems:'center',gap:8}}>
              <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:700,color:'#BF360C',fontSize:'0.95rem'}}>📋 {total.toLocaleString()} Records</div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={downloadPDF} style={{padding:'6px 14px',border:'none',borderRadius:99,background:'linear-gradient(135deg,#B71C1C,#E53935)',color:'white',fontWeight:700,fontSize:'0.75rem',cursor:'pointer',boxShadow:'0 3px 8px rgba(183,28,28,0.35)'}}>📄 PDF</button>
                <button onClick={downloadExcel} style={{padding:'6px 14px',border:'none',borderRadius:99,background:'linear-gradient(135deg,#1B5E20,#2E7D32)',color:'white',fontWeight:700,fontSize:'0.75rem',cursor:'pointer',boxShadow:'0 3px 8px rgba(27,94,32,0.35)'}}>📊 Excel</button>
              </div>
            </div>
            <div style={{overflowX:'auto',maxHeight:'calc(100vh - 220px)',overflowY:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.78rem',fontFamily:"'Outfit',sans-serif"}}>
                <thead style={{position:'sticky',top:0,zIndex:5}}>
                  <tr style={{background:'linear-gradient(135deg,#E55100,#FF6B00)',color:'white'}}>
                    {['#','Name','Relative','G/Age','District','Booth','Community','Profession','Status'].map(h=>(
                      <th key={h} style={{padding:'9px 10px',textAlign:'left',fontWeight:700,fontSize:'0.72rem',whiteSpace:'nowrap'}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row,i)=>(
                    <tr key={i} style={{borderBottom:'1px solid rgba(255,107,0,0.05)',transition:'background 0.1s'}}
                    onMouseEnter={e=>e.currentTarget.style.background='rgba(255,107,0,0.03)'}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                      <td style={{padding:'8px 10px',color:'#9E6040',fontSize:'0.7rem'}}>{i+1}</td>
                      <td style={{padding:'8px 10px',fontWeight:600,color:'#1A0A00'}}>{row.name}</td>
                      <td style={{padding:'8px 10px',color:'#5C3010'}}>{row.relation_name||'—'}</td>
                      <td style={{padding:'8px 10px'}}><span style={{background:row.gender==='M'?'#E3F2FD':'#FCE4EC',color:row.gender==='M'?'#1565C0':'#880E4F',padding:'2px 7px',borderRadius:99,fontWeight:700,fontSize:'0.7rem'}}>{row.gender}/{row.age}</span></td>
                      <td style={{padding:'8px 10px',color:'#5C3010',fontSize:'0.78rem'}}>{row.district||'—'}</td>
                      <td style={{padding:'8px 10px',fontWeight:700,color:'#E55100'}}>{row.booth_number||'—'}</td>
                      <td style={{padding:'8px 10px',color:'#333',fontSize:'0.76rem'}}>{row.community||'—'}</td>
                      <td style={{padding:'8px 10px',color:'#333',fontSize:'0.76rem'}}>{row.profession||'—'}</td>
                      <td style={{padding:'8px 10px'}}><span style={{background:row.status==='Available'?'#E8F5E9':'#F5F5F5',color:row.status==='Available'?'#1B5E20':'#666',padding:'2px 7px',borderRadius:99,fontWeight:700,fontSize:'0.7rem'}}>{row.status||'None'}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}